module.exports = __webpack_public_path__ + "static/media/bakaefing.33880b7b.png";